<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data PostingSupplyCase">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="postingSupplyDetailForProductions" optionsLabel="pickingSupplyForProductionDetail" optionsKey="id" label-cols-lg="12" label="Posting Supply Detail For Production" id="input-" size="sm" :model.sync="model.postingSupplyDetailForProductionId"   :selected="model.postingSupplyDetailForProduction != null ? model.postingSupplyDetailForProduction.pickingSupplyForProductionDetail : ''" @input="getPostingSupplyDetailForProductions" />
				<app-input-combobox-autocomplete :options="pickingSupplyForProductionDetails" optionsLabel="materialPart" optionsKey="id" label-cols-lg="12" label="Picking Supply Detail For Production" id="input-" size="sm" :model.sync="model.pickingSupplyDetailForProductionId"   :selected="model.pickingSupplyDetailForProduction != null ? model.pickingSupplyDetailForProduction.materialPart : ''" @input="getPickingSupplyForProductionDetails" />
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty" label-cols-lg="12" label="Qty" label-for="input-qty" size="sm" :model.sync="model.qty"  />
				<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="input-" size="sm" :model.sync="model.areaId"   :selected="model.area != null ? model.area.code : ''" @input="getAreas" />
				<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Rack" id="input-" size="sm" :model.sync="model.rackId"   :selected="model.rack != null ? model.rack.code : ''" @input="getRacks" />
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="input-" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PostingSupplyCase from '@/models/PostingSupplyForProduction/PostingSupplyCase';
import PostingSupplyCaseFilter from '@/filters/PostingSupplyForProduction/PostingSupplyCaseFilter';

import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';
import PostingSupplyForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyForProductionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PostingSupplyDetailForProduction from '@/models/PostingSupplyForProduction/PostingSupplyDetailForProduction';
import PostingSupplyDetailForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyDetailForProductionFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			postingSupplyDetailForProductions : [],
			pickingSupplyForProductionDetails : [],
			controlCards : [],
			parts : [],
			areas : [],
			racks : [],
			documentStatuss : [],
			isBusy: false,
		}
	},
	methods : {
		getPostingSupplyCase : async function(id) {
			this.isBusy = true;
			PostingSupplyCase.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getPostingSupplyDetailForProductions : async function(input) {
			let filter = new PostingSupplyDetailForProductionFilter();
			if (input != undefined) {
				filter.pickingSupplyForProductionDetail = input;
			}
			PostingSupplyDetailForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.postingSupplyDetailForProductions = result.data
				}
			})
			.catch(error => {});
		},
		getPickingSupplyForProductionDetails : async function(input) {
			let filter = new PickingSupplyForProductionDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			PickingSupplyForProductionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductionDetails = result.data
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getPostingSupplyDetailForProductions();
		//this.getPickingSupplyForProductionDetails();
		//this.getControlCards();
		//this.getParts();
		//this.getAreas();
		//this.getRacks();
		//this.getDocumentStatuss();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPostingSupplyCase(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getPostingSupplyDetailForProductions();
				this.getPickingSupplyForProductionDetails();
				this.getControlCards();
				this.getParts();
				this.getAreas();
				this.getRacks();
				this.getDocumentStatuss();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPostingSupplyCase(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
